/**
 * Escapes a value for CSV format
 * Handles commas, quotes, and newlines by wrapping in quotes and escaping internal quotes
 */
export const escapeCSV = (value: string | number | null | undefined): string => {
  if (value == null) return ''
  const stringValue = String(value)
  if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
    return `"${stringValue.replace(/"/g, '""')}"`
  }
  return stringValue
}

/**
 * Downloads data as a CSV file
 * @param headers - Array of column header names
 * @param rows - Array of arrays representing data rows (each inner array should match headers length)
 * @param filename - Name of the file to download (without .csv extension)
 */
export const downloadCSV = (headers: string[], rows: (string | number)[][], filename: string): void => {
  // Combine headers and rows into CSV content
  const csvContent = [
    headers.map(escapeCSV).join(','),
    ...rows.map((row) => row.map(escapeCSV).join(',')),
  ].join('\n')

  // Create download link
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
  const link = document.createElement('a')
  const url = URL.createObjectURL(blob)
  link.setAttribute('href', url)
  link.setAttribute('download', `${filename}_${new Date().toISOString().split('T')[0]}.csv`)
  link.style.visibility = 'hidden'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}
